import { supabase } from '@/core/supabase/client';

/**
 * Darse de baja.
 *
 * Las dos decisiones —si se puede, y qué se lleva puesto— las toma la base, no
 * esta pantalla. Acá sólo se dibuja lo que contestó. Ver la migración 66.
 */

export interface OrganizacionNombrada {
  id: string;
  name: string;
}

export interface AvisoDeBaja {
  /** `false` cuando hay que pasar el mando antes de poder irse. */
  puede: boolean;
  /** Organizaciones donde es el único administrador y trabaja más gente. */
  hay_que_pasar_el_mando: OrganizacionNombrada[];
  /** Organizaciones que quedarían sin nadie adentro. */
  quedan_sin_nadie: OrganizacionNombrada[];
  /** La propia dirección, para pedir que la escriba quien se va. */
  mi_correo: string;
}

export interface ResultadoDeBaja {
  baja: boolean;
  organizaciones_dejadas: number;
  organizaciones_sin_nadie: number;
}

/**
 * Qué pasaría si me diera de baja.
 *
 * Se consulta ANTES de mostrar el botón. Dejar que la persona decida irse,
 * escriba su correo para confirmar y recién ahí reciba «sos el único
 * administrador» es avisarle en el peor momento posible.
 */
export async function fetchAvisoDeBaja(): Promise<AvisoDeBaja> {
  const { data, error } = await supabase.rpc('my_account_deletion_preview');
  if (error) throw error;
  return data as AvisoDeBaja;
}

/**
 * La baja, de verdad. No se deshace.
 *
 * `confirmacion` es el correo de la cuenta, escrito por quien se va. La base lo
 * vuelve a verificar: acá no se valida para dejar pasar, se valida para no
 * hacer viajar un pedido que ya se sabe que va a ser rechazado.
 */
export async function darDeBajaMiCuenta(confirmacion: string): Promise<ResultadoDeBaja> {
  const { data, error } = await supabase.rpc('delete_my_account', {
    p_confirmacion: confirmacion,
  });
  if (error) throw error;
  return data as ResultadoDeBaja;
}
